import { DecimalPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { TranslocoModule } from '@jsverse/transloco';
import { GroupSelectOption } from '@rma/generic/ui/forms/group-select';
import { RmaIconComponent } from '@rma/generic/ui/icon';
import { ShortNumberPipe } from '@rma/generic/util/pipes/short-number';
import { ProfileAvatarComponent } from '@rma/profiles/public/ui-profile-avatar';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { FindMyAgentResponseVM, OVERALL_LOCATION_ID } from '../../domain/results';
import { ResultProfileComponent } from '../ui-profile/profile.component';

@Component({
  selector: 'rma-result-table',
  imports: [
    DecimalPipe,
    MatButtonModule,
    MatButtonToggleModule,
    NgScrollbarModule,
    ProfileAvatarComponent,
    ReactiveFormsModule,
    ResultProfileComponent,
    RmaIconComponent,
    ShortNumberPipe,
    TranslocoModule,
  ],
  templateUrl: './result-table.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class ResultTableComponent implements OnChanges {
  @Input()
  agents!: FindMyAgentResponseVM[];

  @Input()
  locality!: GroupSelectOption;

  @Input()
  activeLocality = OVERALL_LOCATION_ID;

  @Output()
  seletedLocality = new EventEmitter<string | undefined>();

  @Output()
  agentSelected = new EventEmitter<string>();

  localityControl = new FormControl<string>(OVERALL_LOCATION_ID);
  overallValue = OVERALL_LOCATION_ID;
  showOverallStats = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['activeLocality']) {
      this.localityControl.setValue(this.activeLocality, { emitEvent: false });
      this.showOverallStats = this.activeLocality === OVERALL_LOCATION_ID;
    }
  }

  agentsTrackBy(_index: number, agent: FindMyAgentResponseVM): string {
    return agent.profileCode;
  }
}
